import './_editorial-carousel.scss';
import component from './editorial-carousel';

export default component;
